module.exports = __webpack_public_path__ + "static/media/partner-with-us.8c09f98b.svg";